(() => {
  const root = document.documentElement;
  const navigationKey = 'knollbury-header-logo-navigation';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const isHomepage = document.body.classList.contains('template-name-index');

  const clearPendingState = () => root.classList.remove('header-logo-intro-pending');

  const clearTransitionElements = () => {
    clearPendingState();
    root.classList.remove('header-logo-intro-handoff-pending');
    document.querySelectorAll('.header-logo-exit, .header-logo-intro, .header-logo-intro-backdrop')
      .forEach((element) => element.remove());
  };

  const clearNavigationHandoff = () => {
    try {
      sessionStorage.removeItem(navigationKey);
    } catch (error) {
      // The restored page can still be revealed when storage is unavailable.
    }
  };

  window.addEventListener('pageshow', (event) => {
    const navigationEntry = performance.getEntriesByType?.('navigation')?.[0];
    if (!event.persisted && navigationEntry?.type !== 'back_forward') return;
    clearNavigationHandoff();
    clearTransitionElements();
  });

  const findPrimaryLogo = () => {
    const logoLink = [...document.querySelectorAll('.section-header .header__heading-link')]
      .find((link) => link.querySelector('.header__heading-logo'));
    if (!logoLink) return null;

    return logoLink.querySelector('.header__heading-logo-wrapper:not(.reverted) .header__heading-logo')
      || logoLink.querySelector('.header__heading-logo');
  };

  const startEntrance = () => {
    if (!isHomepage) {
      clearPendingState();
      return;
    }
    if (!root.classList.contains('header-logo-intro-pending')) {
      clearTransitionElements();
      return;
    }
    if (reducedMotion.matches) {
      clearPendingState();
      return;
    }

    const primaryLogo = findPrimaryLogo();
    if (!primaryLogo) {
      clearPendingState();
      return;
    }

    const backdrop = document.querySelector('.header-logo-intro-seed.header-logo-intro-backdrop')
      || document.createElement('div');
    backdrop.classList.add('header-logo-intro-backdrop');
    backdrop.setAttribute('aria-hidden', 'true');

    const intro = document.querySelector('.header-logo-intro-seed.header-logo-intro')
      || document.createElement('div');
    intro.classList.add('header-logo-intro');
    intro.setAttribute('aria-hidden', 'true');

    const introImage = intro.querySelector('.header-logo-intro__image') || document.createElement('img');
    introImage.classList.add('header-logo-intro__image');
    introImage.alt = '';
    introImage.src = primaryLogo.currentSrc || primaryLogo.src;
    if (!introImage.isConnected) intro.appendChild(introImage);
    if (!backdrop.isConnected) document.body.appendChild(backdrop);
    if (!intro.isConnected) document.body.appendChild(intro);

    requestAnimationFrame(() => requestAnimationFrame(() => intro.classList.add('is-centered')));

    backdrop.classList.remove('header-logo-intro-seed');
    intro.classList.remove('header-logo-intro-seed');
    root.classList.remove('header-logo-intro-handoff-pending');

    const minimumIntroTime = new Promise((resolve) => setTimeout(resolve, 1450));
    const pageLoaded = document.readyState === 'complete'
      ? Promise.resolve()
      : new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));

    Promise.all([minimumIntroTime, pageLoaded]).then(() => {
      const target = primaryLogo.getBoundingClientRect();
      const introBounds = intro.getBoundingClientRect();
      const targetX = target.left + target.width / 2 - window.innerWidth / 2;
      const targetY = target.top + target.height / 2 - window.innerHeight / 2;
      const targetScale = target.width / introBounds.width;

      intro.classList.remove('is-handoff');
      intro.style.setProperty('--header-logo-intro-x', `${targetX}px`);
      intro.style.setProperty('--header-logo-intro-y', `${targetY}px`);
      intro.style.setProperty('--header-logo-intro-scale', targetScale);
      intro.classList.add('is-docking');
      backdrop.classList.add('is-clearing');

      setTimeout(() => {
        clearPendingState();
        intro.classList.add('is-finished');
        setTimeout(() => {
          intro.remove();
          backdrop.remove();
        }, 240);
      }, 1050);
    }).catch(() => {
      clearPendingState();
      intro.remove();
      backdrop.remove();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startEntrance, { once: true });
  } else {
    startEntrance();
  }
})();
